export const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL;
// Search service (listing search, hotel room availability).
export const SEARCH_SERVICE_URL = process.env.NEXT_PUBLIC_SEARCH_SERVICE_URL;
export const APP_URL = process.env.NEXT_PUBLIC_URL ?? "";
// Raw chat WebSocket base URL (client appends ?token=<JWT>). Docs: documentation/features/chat/architecture/websocket-contract.md
export const CHAT_WS_URL = process.env.NEXT_PUBLIC_CHAT_WS_URL;
// Conversation service REST base URL (message send POSTs here, not BASE_URL).
export const CONVERSATION_API_URL =
  process.env.NEXT_PUBLIC_CONVERSATION_API_URL;
// Python service REST base URL (blogs, boost analytics — not BASE_URL).
export const PYTHON_SERVICE_URL = process.env.NEXT_PUBLIC_PYTHON_SERVICE_URL;

/**
 * True while `next build` prerenders. An ISR page whose backend fails then still renders
 * its fallback (a deploy mustn't fail on a brief outage); at runtime it throws instead,
 * so Next keeps serving the last good copy rather than caching the failure.
 */
export const IS_BUILD = process.env.NEXT_PHASE === "phase-production-build";

// Platform sent as `os_platform` on API payloads: 1 = app, 3 = web.
export const OS_PLATFORM_WEB = 3;

/**
 * How the search page presents its filters on a wide screen:
 *   "sidebar" — a persistent left column, results beside it (default)
 *   "modal"   — a Filters button opening a centered dialog
 * Set `NEXT_PUBLIC_SEARCH_FILTER_LAYOUT` to switch. Below `lg` both layouts
 * fall back to the bottom sheet, since a sidebar has nowhere to go on a phone.
 */
export type SearchFilterLayout = "modal" | "sidebar";

export const SEARCH_FILTER_LAYOUT: SearchFilterLayout =
  process.env.NEXT_PUBLIC_SEARCH_FILTER_LAYOUT === "modal"
    ? "modal"
    : "sidebar";
